import React, { Component } from 'react'


export default class StatusBoleto extends Component {
    render() {
        return (
            <div className={`container-alert  ${this.props.theme}`}>
                <div className="icon">
                    <div className='icon-content'>
                        <img src={this.props.image} alt={this.props.altIcon} />
                        <p className="title">{this.props.title}</p>
                    </div>

                    <img src="/assets/images/icons/close-circle.svg" className='close-icon' alt="close" onClick={this.props.onClose} />

                </div>
                <div className="infos">
                    {this.props.children}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/common/BoxAlert/index.jsx